import DetailsCard from './DetailsCard'

export default DetailsCard